import React from 'react'
import Latest_updates from './latest_updates/Latest_updates'
import Trending from './trending/Trending'

function Latest_news() {
  return (
    <>
    <Latest_updates/>
    <Trending/>
    </>
  )
}

export default Latest_news